import HTMLModal, { HTMLModalProps } from "./HTMLModal";
import IFrameModal, { IFrameModalProps } from "./IFrameModal";
import SimpleModal, { SimpleModalProps } from "./Modal";

export default {
	HTML: HTMLModal,
	IFrame: IFrameModal,
	Simple: SimpleModal,
};
